export class EnumModel {
  public id: number;
  public name: string;

  constructor(id?: number, name?: string) {
    this.id = id;
    this.name = name;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/enum.model.ts